declare global {
    interface Window {
        gtag?: (...args: any[]) => void;
    }
}

type Params = Record<string, any>;

export function trackEvent(name: string, params: Params = {}) {
    if (!window.gtag) return;

    window.gtag("event", name, {
        app: "dashboard",
        iframe: window.parent !== window,
        ...params,
    });
}

export function trackPageView(path: string) {
    if (!window.gtag) return;

    window.gtag("event", "page_view", {
        page_path: path,
        page_location: window.location.href,
        iframe: window.parent !== window,
    });
}